<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 hourly-sales" id="hourly-sales">
    <po-widget>
      <span class="po-font-text-bold title">Conversão de condicionais</span>
      <span class="po-ml-1 po-icon po-icon-xml pointer-cursor" *ngIf="!loading && !errorApi" (click)="downloadExcel()"></span>
      <div class="icon-loading" *ngIf="loading && !errorApi">
        <app-loading-icon></app-loading-icon>
      </div>
      <div *ngIf="!loading && errorApi">
        <app-error [message]="message"></app-error>
      </div>
      <div style="overflow: hidden;" *ngIf="!loading && !errorApi">
        <fusioncharts
          [width]="width"
          [height]="height"
          [type]="type"
          [dataFormat]="dataFormat"
          [dataSource]="dataSource"
        ></fusioncharts>
      </div>
    </po-widget>
  </div>